import React from 'react';
import Link from './LocalizedLink';

import { Code } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer 
      data-testid="footer"
      className="py-12 bg-[var(--color-surface)] border-t border-[var(--color-border)]"
    >
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo */}
          <Link to="/" className="text-xl font-extrabold tracking-tight" style={{ fontFamily: 'Outfit, sans-serif' }}>
            <span className="text-[var(--color-text)]">Faccio</span>
            <span className="text-[var(--color-primary)]">App</span>
          </Link>

          {/* Links */}
          <div className="flex flex-wrap items-center justify-center gap-6">
            <Link to="/come-funziona" className="text-sm text-[var(--color-text-muted)] hover:text-[var(--color-text)]">
              {t('nav.come_funziona')}
            </Link>
            <Link to="/tariffe" className="text-sm text-[var(--color-text-muted)] hover:text-[var(--color-text)]">
              {t('nav.prezzi')}
            </Link>
            <Link to="/per-chi" className="text-sm text-[var(--color-text-muted)] hover:text-[var(--color-text)]">
              {t('nav.per_chi')}
            </Link>
            <Link to="/contatti" className="text-sm text-[var(--color-text-muted)] hover:text-[var(--color-text)]">
              {t('nav.contatti')}
            </Link>
          </div>
        </div>

        <div className="section-divider my-8" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <Link to="/privacy" className="text-xs text-[var(--color-text-muted)] hover:text-[var(--color-text)]">
              {t('footer.privacy')}
            </Link>
            <Link to="/termini" className="text-xs text-[var(--color-text-muted)] hover:text-[var(--color-text)]">
              {t('footer.termini')}
            </Link>
          </div>
          <p className="text-xs text-[var(--color-text-muted)] flex items-center gap-1">
            <Code className="w-3 h-3" /> {t('footer.made_with')} • © 2025 FaccioApp
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
